import { render, staticRenderFns } from "./inforShareMsg.vue?vue&type=template&id=400bcd59&"
import script from "./inforShareMsg.vue?vue&type=script&lang=js&"
export * from "./inforShareMsg.vue?vue&type=script&lang=js&"
import style0 from "./inforShareMsg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('400bcd59')) {
      api.createRecord('400bcd59', component.options)
    } else {
      api.reload('400bcd59', component.options)
    }
    module.hot.accept("./inforShareMsg.vue?vue&type=template&id=400bcd59&", function () {
      api.rerender('400bcd59', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/inforShareMsg.vue"
export default component.exports